import { Injectable } from '@produce8/pegasus';

@Injectable()
export class StaticEnvironmentAdapter {
  static cubejs_api_endpoint: string;
}
